import { html, LitElement } from 'lit-element'
import { t } from '../../directives/translate'
import styles from './integration-disconnected-page.styles.scss'
import { DOWNLOAD_MS_TEAMS_PLUGIN_URL, START_MS_TEAMS_PLUGIN_INTERNAL_ROUTE } from '../../core/integrations-helpers'
import { getLocationOrigin } from '../../common/dom-helpers'

export class IntegrationDisconnectedPage extends LitElement {
  static readonly tagName = 'goto-integration-disconnected-page'

  static get styles() {
    return styles
  }

  render() {

    const startPluginUrl = new URL(START_MS_TEAMS_PLUGIN_INTERNAL_ROUTE, getLocationOrigin()).href

    return html` <chameleon-goto-logo></chameleon-goto-logo>
      <div class="integration-disconnected-container">
        <chameleon-typography variant="heading-large" class="container-title">
          ${t('Start the GoTo plugin')}
        </chameleon-typography>
        <chameleon-typography variant="body-large" class="container-description">
          ${t('For calls to work in Microsoft Teams, you must run the GoTo plugin on your desktop.')}
        </chameleon-typography>
        <chameleon-typography variant="body-large" class="container-description">
          ${t('If prompted, allow your browser to open the plugin.')}
        </chameleon-typography>
        <chameleon-typography variant="body-large">${t('Plugin not starting?')}</chameleon-typography>
        <div class="user-action-container">
          <chameleon-link id="start" href="${startPluginUrl}" target="_blank" variant="body-large">${t('Try again')}</chameleon-link>
          <chameleon-typography variant="body-large" color="type-color-secondary-inverted" class="divider"
            >|</chameleon-typography
          >
          <chameleon-link id="download" href="${DOWNLOAD_MS_TEAMS_PLUGIN_URL}" target="_blank" variant="body-large">${t('Download again')}</chameleon-link>
        </div>
      </div>`
  }
}

declare global {
  interface HTMLElementTagNameMap {
    readonly [IntegrationDisconnectedPage.tagName]: IntegrationDisconnectedPage
  }
}
